import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown, Icon } from "semantic-ui-react";
import "./SideBarMenu.css";
import { ApplicationMode } from "../../lib/store/types/ApplicationStateTypes";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import { reloadBoxReview, setBoxReviewAction } from "../../lib/store/reducers/boxReviewReducer";
import  BoxReviewConstants from "../../lib/boxReview/Constants";
import { LimaOperatorTask } from "../../typewriterModels/CommonEnum";
import { setRxInputTask, setRxSingleTransportCart, setRxNormalTransportCart} from "../../lib/store/reducers/rxBoxModeReducer";

const { ActionStates } = BoxReviewConstants;

export class SideBarMenu extends Component {
  _changeCart = (e) => {
    this.props.changeCart(-1, false);
  };

  _switchMode = () => {
      const { clearPersistedState,  clearCartState } = this.props;
      const { boxReviewAction, sortBoxModel } = this.props.boxReviewState;
      if (boxReviewAction === ActionStates.COMPLETE_BOX || boxReviewAction === ActionStates.PACK_MODE) {
        clearPersistedState();
        clearCartState();
        this.props.setBoxReviewAction(ActionStates.LOAD_BOX);
      } else if (boxReviewAction === ActionStates.LOAD_BOX) {
        this.props.reloadBoxReview(false);
        
        if (sortBoxModel === null) {
          this.props.setBoxReviewAction(ActionStates.PACK_MODE);
        } else {
          this.props.setBoxReviewAction(ActionStates.COMPLETE_BOX);
        }
      }
  }

  _setOrCloseRxTranportcart = (isSingleCart) => {
    const { singleTransportCart, normalTransportCart} = this.props.rxAppState;
    if (isSingleCart){
      if (singleTransportCart === null) this.props.setRxInputTask(LimaOperatorTask.RegisterSingleTransportCart);
      else this.props.setRxSingleTransportCart(null);
    }else{
      if (normalTransportCart === null) this.props.setRxInputTask(LimaOperatorTask.RegisterNormalTransportCart);
      else this.props.setRxNormalTransportCart(null);
    }
  }

  render() {
    const { appMode } = this.props.appState;
    const { boxReviewAction, currentBox } = this.props.boxReviewState;
    const { branchID } = this.props.loginState;
    const { singleTransportCart, normalTransportCart, inputTask } = this.props.rxAppState;
    let {
      startSingel,
      searchBox,
      changeCart,
      logOut,
      partialDelivery,
      restartDelivery,
      leftoverOrders,
      menuOpen,
      menuClose,
      scanNewOrder,
      clearBoxReview,
      closeFinishedOrder,
      purgeQueue
    }  = this.props;
    return (
      <Dropdown
        button
        icon="list"
        className="SideBarMenu"
        onOpen={() => (menuOpen ? menuOpen() : null)}
        onClose={() => (menuClose ? menuClose() : null)}
      >
        <Dropdown.Menu>
        {appMode === ApplicationMode.BoxReviewMode ? (
            <Dropdown.Item onClick={() => this._switchMode()}>
              <Icon name="exchange" />
              {boxReviewAction === ActionStates.LOAD_BOX ? "Byt till pack-läge": "Byt till Kontrollstation-läge"}
            </Dropdown.Item>  
          ) : (
            ""
          )}
          {appMode === ApplicationMode.RxBoxMode && branchID == 10 && inputTask !== LimaOperatorTask.RegisterSingleTransportCart ? (
            <Dropdown.Item onClick={() => this._setOrCloseRxTranportcart(true)}  style={{color:'#573a08'}}>
              <Icon name="cube" />
              {singleTransportCart == null ? "Scanna singeltransportback": "Avsluta singeltransportback"}
            </Dropdown.Item>
          ) : (
            ""
          )}
          {appMode === ApplicationMode.RxBoxMode && branchID == 10 && inputTask !== LimaOperatorTask.RegisterNormalTransportCart ? (
            <Dropdown.Item onClick={() => this._setOrCloseRxTranportcart(false)} style={{color:'#276f86'}}>
              <Icon name="cube" />
              {normalTransportCart == null ? "Scanna transportback": "Avsluta transportback"}
            </Dropdown.Item>
          ) : (
            ""
          )}
          {appMode === ApplicationMode.RxBoxMode && typeof closeFinishedOrder === "function" ? (
            <Dropdown.Item onClick={() => closeFinishedOrder()} style={{color:'#276f86'}}>
              <Icon name="check" />
               Stäng avslutad order
            </Dropdown.Item>
          ) : (
            ""
          )}
          {appMode === ApplicationMode.RxBoxMode && purgeQueue && typeof purgeQueue === "function" ? (
            <Dropdown.Item onClick={() => purgeQueue()} style={{color:'#276f86'}}>
              <Icon name="sync" />
              Rätta kö
            </Dropdown.Item>
          ) : (
            ""
          )}
          {scanNewOrder ? (
            <Dropdown.Item onClick={() => scanNewOrder(true)}>
              <Icon name="recycle" />
              Starta ny kontroll
            </Dropdown.Item>
          ) : (
            ""
          )}
          {restartDelivery ? (
            <Dropdown.Item onClick={restartDelivery}>
              <Icon name="redo alternate" />
              Börja om leverans
            </Dropdown.Item>
          ) : (
            ""
          )}
          {leftoverOrders ? (
            <Dropdown.Item onClick={leftoverOrders}>
              <Icon name="clipboard"></Icon>Överblivna ordrar
            </Dropdown.Item>
          ) : (
            ""
          )}
          {partialDelivery ? (
            <Dropdown.Item onClick={partialDelivery}>
              <Icon name="boxes" />
              Delleverans
            </Dropdown.Item>
          ) : (
            ""
          )}
          {startSingel ? (
            <Dropdown.Item onClick={startSingel}>
              <Icon name="box" />
              RX-Singel
            </Dropdown.Item>
          ) : (
            ""
          )}
          {searchBox ? (
            <Dropdown.Item onClick={searchBox}>
              <Icon name="find" />
              Hitta Låda
            </Dropdown.Item>
          ) : (
            ""
          )}
          {changeCart ? (
            <Dropdown.Item onClick={() => this._changeCart()}>
              <Icon name="exchange" />
              Byt vagn
            </Dropdown.Item>
          ) : (
            ""
          )}
          {clearBoxReview && currentBox !== null && false ? (
            <Dropdown.Item onClick={() => clearBoxReview()}>
              <Icon name="close icon" />
              Avbryt
            </Dropdown.Item>
          ) : (null)
          }
          {logOut ? (
            <Dropdown.Item onClick={logOut}>
              <Icon name="sign-out" />
              Logga ut
            </Dropdown.Item>
          ) : (
            ""
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appState: state.applicationStateReducer,
    boxReviewState: state.boxReviewReducer,
    loginState: state.loginInfoReducer,
    rxAppState: state.rxModeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  const boxReviewActions = {
    setBoxReviewAction: (action) => dispatch(setBoxReviewAction(new PayloadWrapper(action))),
    reloadBoxReview: (reload) => dispatch(reloadBoxReview(new PayloadWrapper(reload))),
    setRxInputTask : (operatorTask) => dispatch(setRxInputTask(new PayloadWrapper(operatorTask))),
    setRxSingleTransportCart : (transportCart) => dispatch(setRxSingleTransportCart(new PayloadWrapper(transportCart))),
    setRxNormalTransportCart : (transportCart) => dispatch(setRxNormalTransportCart(new PayloadWrapper(transportCart))),
  };

  return { ...boxReviewActions };
};


export default connect(mapStateToProps, mapDispatchToProps)(SideBarMenu)
